import translate from '../../translations'

export default data => {
  const str = `<div class="card__inner">
            <div class="card__top">
                <div class="card__heading">
                    <div>
                        <svg class="icon icon--${
  data.socialnetwork.type
}" aria-hidden="true">
                            <use href="#icon-${
  data.socialnetwork.type
}" xlink:href="#icon-${
  data.socialnetwork.type
}"></use>
                        </svg>
                        <span>${data.socialnetwork.name}</span>
                    </div>
                    <span class="card__date">${data.date}</span>
                </div>
                <div class="card__content wysiwyg">
                    ${data.desc}
                </div>
            </div>
            <div class="card__bottom">
                <a href="${
  data.socialnetwork.url
}" class="button button-icon button--blue-dark" target="_blank" rel="nofollow">
                    <div>
                        <svg class="icon icon--red" aria-hidden="true">
                            <use href="#icon-${
  data.socialnetwork.type
}" xlink:href="#icon-${
  data.socialnetwork.type
}"></use>
                        </svg>
                        <span>${translate('SEE_POST')}</span>
                    </div>
                </a>
            </div>
        </div>`

  return str
}
